import { useState, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { updateCommande } from "../../../../REDUX/actions/commandes";
import {
  createDelivery,
  updateDelivery,
  deleteDelivery,
  getDeliveryNumber,
} from "../../../../REDUX/actions/delivery";
import { closeCenteredModal } from "../../../../REDUX/actions/centeredModal";
import API from "../../../../Api/Api";
import moment from "moment";

export const useDeliveryForm = ({
  estimatedDeliveryDate,
  realDeliveryDate,
  orderId,
  isEstimatedDate,
  currentTransporter,
}) => {
  const { orderDeliveries } = useSelector((state) => state.deliveryReducer);
  const dispatch = useDispatch();

  const [formData, setFormData] = useState({
    estimatedDeliveryDate,
    realDeliveryDate,
    orders: [orderId],
  });

  const handleChange = useCallback(
    (name) => (value) => {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
    },
    [],
  );

  const handleSubmit = useCallback(async () => {
    const updateData = isEstimatedDate
      ? {
          estimatedDeliveryDate: moment(formData.estimatedDeliveryDate)
            .utc(true)
            .toDate(),
        }
      : {
          realDeliveryDate: moment(formData.realDeliveryDate)
            .utc(true)
            .toDate(),
        };

    for (let i = 0; i < formData.orders.length; i++) {
      await dispatch(updateCommande(formData.orders[i], updateData));
    }

    // Check for deselected orders and delete their deliveries
    const selectedOrderIds = formData?.orders || [];
    const deliveriesToDelete = orderDeliveries?.filter(
      (delivery) =>
        !selectedOrderIds.includes(delivery?.attributes?.commande?.data?.id),
    );

    // Delete deliveries for deselected orders
    for (let delivery of deliveriesToDelete) {
      await dispatch(deleteDelivery(delivery.id));
    }

    // Create or update deliveries for selected orders
    let deliveryIds = [];
    for (let i = 0; i < formData?.orders?.length; i++) {
      const delivery = orderDeliveries?.find(
        (item) => item?.attributes?.commande?.data?.id === formData.orders[i],
      );
      const nextNumber = await getDeliveryNumber(delivery?.id);
      const isFound = delivery;

      const deliveryPayload = {
        commande: formData.orders[i],
        date: isEstimatedDate
          ? moment(formData.estimatedDeliveryDate).utc(true).toDate()
          : moment(formData.realDeliveryDate).utc(true).toDate(),
        number: nextNumber,
      };

      if (isFound) {
        await dispatch(updateDelivery(delivery.id, deliveryPayload));
        deliveryIds.push(delivery.id);
      } else {
        const data = await dispatch(createDelivery(deliveryPayload));
        deliveryIds.push(data?.id);
        if (!isEstimatedDate) {
          try {
            await API.post(`api/delivery/send-email`, {
              data: {
                id: data?.id,
              },
            });
          } catch (error) {
            console.log(error);
          }
        }
      }
    }
    if (currentTransporter) {
      const { data } = await API.get(`api/deliveries`, {
        params: {
          filters: {
            transporter: {
              id: {
                $eq: currentTransporter?.id,
              },
            },
          },
        },
      });
      const currentDeliveryIds =
        data?.data?.map((delivery) => delivery?.id) ?? [];
      await API.put(`api/transporters/${currentTransporter?.id}`, {
        data: {
          deliveries: [
            ...currentDeliveryIds,
            ...deliveryIds?.filter((id) => id !== null),
          ],
        },
      });
    }

    dispatch(closeCenteredModal());
  }, [
    dispatch,
    isEstimatedDate,
    formData,
    orderDeliveries,
    currentTransporter,
  ]);

  const handleCancel = useCallback(() => {
    dispatch(closeCenteredModal());
  }, [dispatch]);

  return {
    formData,
    setFormData,
    handleChange,
    handleSubmit,
    handleCancel,
  };
};
